document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-product-root]").forEach((root) => {
    const select = root.querySelector("[data-variant-select]");
    const variantsElement = root.querySelector("[data-product-variants]");
    const optionGroups = [...root.querySelectorAll("[data-product-option]")];
    const price = root.querySelector("[data-product-price]");
    const addButton = root.querySelector("[data-add-button]");
    const addLabel = root.querySelector("[data-add-label]");
    const isPreorder = root.dataset.preorder === "true";

    if (!select) return;

    let variants = [];
    if (variantsElement) {
      try {
        variants = JSON.parse(variantsElement.textContent);
      } catch (error) {
        console.warn("Tailing Co. variant data could not be read.", error);
      }
    }

    const updateVariant = () => {
      const option = select.options[select.selectedIndex];
      const available = option?.dataset.available === "true";
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
      if (addButton) addButton.disabled = !available;
      if (addLabel) addLabel.textContent = available ? (isPreorder ? "Preorder Now" : "Add to cart") : "Sold out";
      if (option?.value) {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", option.value);
        window.history.replaceState({}, "", url);
      }
    };

    const selectMatchingVariant = () => {
      const selectedOptions = optionGroups.map((group) => {
        const checked = group.querySelector("input:checked") || group.querySelector("input");
        if (checked && !checked.checked) checked.checked = true;
        const label = group.querySelector("[data-option-value]");
        if (label && checked) label.textContent = checked.value;
        return checked?.value;
      });
      const variant = variants.find((candidate) =>
        candidate.options.every((value, index) => value === selectedOptions[index])
      );
      if (variant) {
        select.value = String(variant.id);
        updateVariant();
      } else {
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = "Unavailable";
      }
    };

    optionGroups.forEach((group) => {
      group.addEventListener("change", selectMatchingVariant);
    });
    select.addEventListener("change", updateVariant);
    if (optionGroups.length) selectMatchingVariant();
    else updateVariant();
  });

  document.querySelectorAll(".tc-mobile-menu__panel a").forEach((link) => {
    link.addEventListener("click", () => {
      const details = link.closest("details");
      if (details) details.removeAttribute("open");
    });
  });
});
